
import { Expose } from "class-transformer";

export class Token {

	value:string;
	expires:number;

}
